import { Get, Post, Put, Delete } from "../../utils/http-utils";

export const createPackage = async (jsonPayload) => {
  return Post("/scm/package", jsonPayload)
    .then((data) => {
      return data;
    })
    .catch((err) => {
      throw err;
    });

}

export const publishPackage = async (jsonPayload) => {
  return Put("/scm/package/publish", jsonPayload)
    .then((data) => {
      return data;
    })
    .catch((err) => {
      throw err;
    });

}

export const updatePackage = async (jsonPayload) => {
  return Put("/scm/package", jsonPayload)
    .then((data) => {
      return data;
    })
    .catch((err) => {
      throw err;
    });
}

 
export const deletePackage = async (jsonPayload) => {
  return Delete("/scm/package", jsonPayload)
    .then((data) => {
      return data;
    })
    .catch((err) => {
      throw err;
    });
}

export const getPackageInfo = async (params) => {
  try {
    const data = await Get("/scm/package", params);

    if (!Array.isArray(data)) return [];

    return data.flatMap(pkg => {
      const pkgName = pkg?.packageName;
      if (!Array.isArray(pkg?.versions)) return [];

      return pkg.versions.map(ver => {
        const {
          versionName,
          description,
          status,
          tags = {}
        } = ver;

        // Parse recipe JSON safely
        let job_type, clear_target, destination, s3_bucket, s3_keys;
        try {
          const recipeObj = JSON.parse(ver.recipe);
          job_type = recipeObj?.job_type;
          clear_target = recipeObj?.files?.clear_target;
          destination = recipeObj?.files?.destination;
          s3_bucket = recipeObj?.files?.s3_bucket;
          s3_keys = recipeObj?.files?.s3_keys || [];
        } catch (e) {
          console.warn("Invalid recipe JSON:", ver.recipe);
        }

        return {
          packageName: pkgName,
          version: versionName,
          description,
          status,
          expiration: tags?.Expiry_Date || null,
          assetType: tags?.Asset_Type || null,
          dependencies: tags?.Dependency || [],
          jobType: job_type,
          clearTarget: clear_target,
          destination,
          s3Keys: s3_keys
        };
      });


    });
  } catch (err) {
    console.error("Error fetching package info", err);
    return [];
  }
};




